import {Component, Input} from '@angular/core';
import {DatePipe, NgForOf, NgIf, SlicePipe} from "@angular/common";
import {Panel} from "primeng/panel";
import {Router} from "@angular/router";
import {PrimeTemplate} from "primeng/api";

@Component({
  selector: 'app-news-widget',
  standalone: true,
  imports: [
    NgIf,
    Panel,
    NgForOf,
    SlicePipe,
    DatePipe,
    PrimeTemplate
  ],
  templateUrl: './news-widget.component.html',
  styleUrl: './news-widget.component.less'
})
export class NewsWidgetComponent {
  @Input() content: any[] = [];

  constructor(private router: Router) {}

  goToAllNews(): void {
    this.router.navigate(['/news']);
  }
}
